module.exports = __webpack_public_path__ + "media/bootstrap-icons/node-plus-4ce47eff.svg";